
import { mapGetters } from 'vuex'
import articles from '~/mixins/common/pages/articles'
export default {
    name: 'Index',
    mixins: [articles],
    computed: {
        ...mapGetters({
            footerArticle1: 'cms/footerArticle1',
            footerArticle2: 'cms/footerArticle2',
            footerArticle3: 'cms/footerArticle3',
            footerTermAndCondition: 'cms/footerTermAndCondition',
        }),
    },
    mounted() {
        // Call this store action only when the user is not on the home page but on mobile device
        if (this.$route.path !== '/')
            this.$store.dispatch('cms/footerCMS', {
                platform: this.isMobileOnly() ? 2 : 1,
            })
        this.checkArticles()
    },
    methods: {
        checkArticles() {
            const component = this.$route.query?.component_code
            if (
                component === 'ArticleContent1' &&
                this.hasValidDescription(this.footerArticle1)
            ) {
                this.fetchComp()
            } else if (
                component === 'ArticleContent2' &&
                this.hasValidDescription(this.footerArticle2)
            ) {
                this.fetchComp()
            } else if (
                component === 'ArticleContent3' &&
                this.hasValidDescription(this.footerArticle3)
            ) {
                this.fetchComp()
            } else if (
                component === 'TermsAndConditions' &&
                this.hasValidDescription(this.footerTermAndCondition)
            ) {
                this.fetchComp()
            }
        },
        fetchComp() {
            this.$store.dispatch('cms/cmsComponentCode', {
                platform: this.isMobileOnly() ? 2 : 1,
                component_code: this.$route.query?.component_code,
            })
        },
        hasValidDescription(item) {
            if (!item || !Array.isArray(item.items)) return false

            return item.items.some((i) => {
                const desc = i?.description

                // If description does not exist or is not an object, return true
                if (!desc || typeof desc !== 'object') return true

                // Check if all languages are null
                const allNull = Object.values(desc).every((val) => val == null)
                if (allNull) return true

                // If at least one language has a value, return false
                return false
            })
        },
    },
}
